export default {
  methods:{

    // 获取指定节点层级路径
      $_get_node_path(target_node){
        var path_list = []
        while (true) {
          if(!target_node || JSON.stringify(target_node) === '{}'){
            break;
          }
          path_list.push(target_node.orginal)
          target_node = target_node.getParentNode()

        }
        path_list.reverse()

        return path_list
      },

      // 获取指定节点的根节点
      $_get_current_root(target_node){
        if(target_node.level === 0){
          return target_node
        }

        var parents_node = target_node.getPath()
        var root_node = parents_node.filter(node => node.level === 0)
        return root_node[0]

      },

      //获取节点数据的最大序号
      $_get_max_order(nodes, property){
        var node_ids = []
        if(nodes){
          nodes.forEach(row =>{
            if(property){
              node_ids.push(row[property])
            }else {
              node_ids.push(row.getIndex())
            }
          })
          node_ids.sort()
        }

        return node_ids.length > 0 ? node_ids[node_ids.length - 1] : -1
      },


    get_tree_obj(ref) {
      let ztreeObj = null
      try{
        ztreeObj = this.$refs[ref].ztreeObj
      }catch (e) {
        ztreeObj = null
      }
      return ztreeObj

    },
  }
}



// WEBPACK FOOTER //
// ./src/components/common_page/mixin/ztree_opt_func.js